import * as React from "react";
const SvgCheckboxIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 14, height: 14, rx: 2, stroke: "currentColor", strokeWidth: 2 }));
export default SvgCheckboxIcon;
